import { Constraints } from '@touche-lts/panel-ui/dist'
import { UserRequest } from './add-user-page-store.types'

export const initialUserRequest: UserRequest = {
  id: null,
  emailAddress: '',
  password: '',
  confirmPassword: '',
  newPassword: '',
  firstName: '',
  lastName: '',
  fullName: '',
  skipInvitationEmail: false,
  role: null,
  imageUrl: ''
}

export const userRequestConstraints: Constraints<UserRequest> = {
  emailAddress: {
    presence: true,
    email: true,
    length: { minimum: 2, maximum: 50 }
  },
  firstName: {
    presence: true,
    length: { minimum: 2, maximum: 50 }
  },
  lastName: {
    presence: true,
    length: { minimum: 2, maximum: 50 }
  },
  password: {
    length: { minimum: 6, maximum: 30 }
  },
  confirmPassword: {
    equality: 'password'
  },
  role: {
    presence: true
  }
  // userType: {
  //   presence: true,
  //   inclusion: userTypes
  // },
  // deviceOs: {
  //   inclusion: deviceOsTypes
  // },
  // deviceToken: {
  //   length: { maximum: 256 }
  // }
}
